import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingDowngradePendingDataProvider from '@/components/Billing/BillingDowngradePendingDataProvider.vue';
// @ts-ignore
import WatchVideoButton from '@/components/Billing/WatchVideoButton.vue';
import BillingService from '@/components/Billing/billing-service';
import { PriceMap, ProductType } from '@/components/Billing/billing-types';
import Slider from '@/components/common/Slider.vue';
import { addCommasToNumber, getReadableAmountInDollars } from '@/utils/helpers';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddOnSliderCard',
  props: {
    videoUrl: null,
    priceMap: null,
    sliderValue: null,
    currentQuantity: null,
    productType: null,
    sliderAdditionalText: null
  },
  emits: ["see-price-list", "slider-updated"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'see-price-list'): void;
	(e: 'slider-updated', newV: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	videoUrl?: string;
	priceMap: PriceMap;
	sliderValue: number;
	currentQuantity: number;
	productType: ProductType;
	sliderAdditionalText: string;
}





const { isAnnuallyPlan, useSubscriptionByProductType } = useBilling();
const readableSliderValue = computed(() => {
	if (price.value === undefined) {
		return 'Custom';
	}
	return addCommasToNumber(props.sliderValue);
});
const price = computed(() => props.priceMap[props.sliderValue]);
const priceMapNumericKeys = computed(() =>
	Object.keys(props.priceMap)
		.filter((key) => !isNaN(Number(key)))
		.map(Number)
);
const minTasks = computed(() => Math.min(...priceMapNumericKeys.value));
const maxTasks = computed(() => Math.max(...priceMapNumericKeys.value));
const options = computed(() => ({ min: minTasks.value, max: maxTasks.value, data: props.priceMap }));
const readablePrice = computed(() => {
	if (price.value === undefined) {
		return 'Custom';
	}
	return getReadableAmountInDollars(isAnnuallyPlan.value ? price.value / 12 : price.value);
});
const isCustomPrice = computed(() => price.value === undefined);
const showPendingDowngrade = computed(() => BillingService.isPendingDowngrade(useSubscriptionByProductType.value(props.productType)));

const isCurrentPlan = (value: string) => Number(value) === props.currentQuantity;
const onChange = (newV: string) => {
	emit('slider-updated', Number(newV));
};

return { __sfc: true,emit, props, isAnnuallyPlan, useSubscriptionByProductType, readableSliderValue, price, priceMapNumericKeys, minTasks, maxTasks, options, readablePrice, isCustomPrice, showPendingDowngrade, isCurrentPlan, onChange, BillingDowngradePendingDataProvider, WatchVideoButton, Slider }
}

})